import { makeStyles, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableRow, Tabs, Typography } from "@material-ui/core"
import React, { useState } from "react"

export const Dimosieuseis = () => {

    return (
        <React.Fragment>
            <Typography variant='h5'>Δημοσιεύσεις</Typography>
            <ol>
                <li>
                    <Typography align='justify'><b>BIOHELLAS</b>:
                        Ανάπτυξη και εφαρμογή μεθοδολογιών για τον ποιοτικό έλεγχο-νοθεία των προϊόντων ελιάς, με χρήση σύγχρονων τεχνικών ανάλυσης και χημειομετρίας. (HOLEA).
                        <Typography component='a' href='/holea.pdf' target='_blank'><i>Agrotypos 12/2020</i></Typography>
                     </Typography>
                </li>
                <li>
                    <Typography align='justify'><b>ΜΕΛΑΣ - Ελαιουργία Επιδαύριας Γης</b>: <i>EΛΙΑ & ΕΛΑΙΟΛΑΔΟ τεύχος 94, 12/20-02/21</i> </Typography>
                </li>
            </ol>

        </React.Fragment>
    )
}